import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXingComponent } from './simple-icons-xing.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXingComponent ],
    exports:      [ SimpleIconsXingComponent ],
    bootstrap:    []
})
export class SimpleIconsXingModule {}
